import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import CorouselExample from "./imageCorousel";
import { ocr_languages } from "../assets/Json/laanlist";

function HandwrittenOcr() {
  const [image, setImage] = useState(null);
  const [displayimage, setDisplayImage] = useState(null);
  const [lang, setLang] = useState("");
  const [trans_language, setTransLang] = useState("");
  const [recognizedText, setRecognizedText] = useState("");
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState(null);

  const handleDownload = () => {
    const blob = new Blob([apiData], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "recognized_text.txt";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(file);
        setDisplayImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const performOCR = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("image", image);
      formData.append("lang", lang);

      const response = await axios.post(
        "https://image123.aicte-india.org/handwritten_ocr",
        formData
      );
      setRecognizedText(response.data.result.recognized_text);
      setLoading(false);
    } catch (error) {
      console.error("Error performing OCR:", error);
    }
  };

  // Function to call the API based on the selected language
  const fetchData = async (text, lang) => {
    try {
      setLoading(true);
      const API_URL =
        "https://anuvadini-services.aicte-india.org/api/text-to-text";

      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer d3f7a8e9f2c45b1a7d6e2f9a4b3c7d8e",
      };

      let datapost = {
        text: text,
        outputLanguage: lang,
      };

      const response = await axios.post(API_URL, datapost, { headers });
      setApiData(response.data.translation);
      console.log(response.data.translation);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false); // Ensure to stop the loading state even if there's an error
    }
  };

  // useEffect hook to call the API when lang changes
  useEffect(() => {
    if (trans_language) {
      const textToTranslate = recognizedText;
      const selectedLang = trans_language;
      fetchData(textToTranslate, selectedLang);
    }
  }, [trans_language]);

  return (
    <>
      <div className="banner-allpage-sec">
        <ul className="breadcrumb">
          <li>
            <a href="https://anuvadini.aicte-india.org/">Home</a>
          </li>
          <li>
            <Link to="/HandwrittenAi/">Anuvadini Handwritten AI</Link>
          </li>
        </ul>
        <CorouselExample />
        <div className="banner-content-sec text-center">
          <br />
          <h1 className="first-head">Anuvadini Handwritten AI</h1>
          <h3 className="second-head">
            {/* Translate photos into 30+ Languages In Seconds, whether they are posters, brochures, screenshots, advertisements, product images */}
          </h3>
          <br />
        </div>
      </div>
      <section
        style={{
          textAlign: "center",
          marginTop: -50,
          marginBottom: 40,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="container">
          <div className="text-start row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <label>Language:</label>
              <select
                id="language"
                className="form-control"
                name="language"
                value={lang}
                onChange={(e) => setLang(e.target.value)}
              >
                <option value="asm">Assamese</option>
                <option value="ben">Bengali</option>
                <option value="eng">English</option>
                <option value="guj">Gujarati</option>
                <option value="hin">Hindi</option>
                <option value="mal">Malayalam</option>
                <option value="mar">Marathi</option>
                <option value="nep">Nepali</option>
                <option value="ori">Oriya</option>
                <option value="pan">Punjabi</option>
                <option value="san">Sanskrit</option>
                <option value="tam">Tamil</option>
                <option value="tel">Telugu</option>
                <option value="urd">Urdu</option>
                <option value="pus">Pashto</option>
              </select>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3">
              <label>Image:</label>
              <br />
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={handleImageChange}
              />
              {displayimage && (
                <img src={displayimage} alt="Selected" width="100%" />
              )}
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3">
              <label>Recognized Text:</label>
              <textarea
                className="form-control h-auto w-100"
                rows="10"
                value={recognizedText}
                onChange={(e) => setRecognizedText(e.target.value)}
              />
              <br />
            </div>

            <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-3 text-start">
              {!recognizedText && (
                <>
                  <button
                    className="button green"
                    style={{
                      display: "inline-block",
                      marginRight: 10,
                      marginTop: 30,
                    }}
                    onClick={performOCR}
                  >
                    Submit
                  </button>
                  <br />
                  <br />
                </>
              )}

              {recognizedText && (
                <>
                  <label className="mb-2">Select language to translate:</label>
                  <select
                    id="trans_language"
                    className="form-control"
                    name="trans_language"
                    onChange={(e) => setTransLang(e.target.value)}
                  >
                    {ocr_languages.map((language) => (
                      <option key={language.value} value={language.value}>
                        {language.name}
                      </option>
                    ))}
                  </select>
                </>
              )}

              <br />
              {apiData && (
                <div>
                  <textarea
                    className="form-control h-auto w-100"
                    rows="10"
                    value={apiData}
                  />
                </div>
              )}

              {apiData && (
                <button
                  className="button green"
                  style={{ marginTop: 30 }}
                  onClick={handleDownload}
                >
                  Download as txt file
                </button>
              )}
            </div>
          </div>
        </div>

        {loading && (
          <>
            <div className="mainLoader tnansloader">
              <div className="maxheight">
                <div className="loader"></div>
                <div
                  id="loader_text"
                  style={{
                    fontSize: "30px",
                    color: "#fff",
                    padding: "10px",
                    borderRadius: "5px",
                    zIndex: "9999",
                    display: "block",
                  }}
                  className="overlay"
                >
                  In-progress....
                </div>
              </div>
            </div>
          </>
        )}
      </section>
    </>
  );
}

export default HandwrittenOcr;
